import { AnnualPreviewEndpointResponse } from '../../../@types/AnnualPreview.type';

interface FormattedIncome {
	regime: string;
	regimeValue: number;
	client: string;
	original: {
		regime: string;
		client: string;
	};
	[key: string]: any;
}

export const useIncomes = (response: AnnualPreviewEndpointResponse) => {
	const formattedIncomes: FormattedIncome[] = [];

	response?.incomes?.months?.forEach((income) => {
		const regimeEntries =
			income?.income_by_service_regime?.split(
				income?.income_by_service_regime?.includes('^ ') ? '^ ' : ', ',
			) || [];
		const clientEntries =
			income?.income_by_client?.split(
				income?.income_by_client?.includes('^ ') ? '^ ' : ', ',
			) || [];

		regimeEntries.forEach((regimeEntry, index) => {
			const regimeParts = regimeEntry.trim().split(':');
			const regime = regimeParts[0];
			const regimeValue = parseFloat(regimeParts[1]);

			const clientEntry = clientEntries[index] || '';
			const clientParts = clientEntry.trim().split(':');
			const client = clientParts[0];

			formattedIncomes.push({
				...income,
				regime,
				regimeValue,
				client,
				original: {
					regime: regimeEntry.trim(),
					client: clientEntry.trim(),
				},
			});
		});
	});

	const groupedByRegime = formattedIncomes.reduce<Record<string, any[]>>(
		(acc, income) => {
			const regime = income.regime;
			if (!acc[regime]) {
				acc[regime] = [];
			}
			acc[regime].push(income);
			return acc;
		},
		{},
	);

	const formattedIncomeByRegime = Object.entries(groupedByRegime).map(
		([regime, incomes]) => {
			const groupedByIssuer = incomes.reduce<
				Record<string, { income: number; retained_isr: number }>
			>((acc, income) => {
				const issuer = income.client;
				if (!acc[issuer]) {
					acc[issuer] = { income: 0, retained_isr: 0 };
				}
				acc[issuer].income += income.regimeValue;
				acc[issuer].retained_isr += income.regimeValue;
				return acc;
			}, {});

			const invoicesGrouped = Object.entries(groupedByIssuer).map(
				([issuer, values]) => ({
					issuer,
					income: values.income,
					retained_isr: values.retained_isr,
				}),
			);

			return {
				regime,
				invoices: invoicesGrouped,
			};
		},
	);

	return {
		formattedIncomes: {
			total_incomes: response?.incomes?.total,
			total_isr_retained: response?.incomes?.total,
			total_iva_retained: response?.incomes?.total,
			detail_incomes: formattedIncomeByRegime,
		},
	};
};
